module.exports = __webpack_public_path__ + "img/1.951a2a81.png";